<template lang="pug">
  #account-balance
    .container
      .box
        img(class="title-img", :src="getImgUrl('account-balance/bank-title')")
        .account-balance-container
          img(class="bank-counter", :src="getImgUrl('account-balance/bank-counter-bg')")
          label.bank-amount.black
            strong ${{ currentBalance }}
        p.balance-desc.grey
          span.balance-date {{ $LANG.balance.BALANCE_AT }}
          strong.balance-date {{ lastUpdatedBalance }}
          br
          span.red ${{ nextExpired[0].balance }}&nbsp;
          span {{ $LANG.balance.SMALES_DOLLARS_EXPIRED }}
          span.red {{ nextExpired[0].date }}
          br
          span.red(v-show="nextExpired[1].date !== '-'") ${{ nextExpired[1].balance }}&nbsp;
          span(v-show="nextExpired[1].date !== '-'") {{ $LANG.balance.SMALES_DOLLARS_EXPIRED }}
          span.red(v-show="nextExpired[1].date !== '-'") {{ nextExpired[1].date }}
        p.redeem-desc.grey(v-html="$LANG.balance.REDEEM_DESC")
        .button-container
          .item
            router-link(:to="'/' + $LOCALE + '/dashboard'" gtm-label="account-balance.dashboard")
              img.buttons(:src="getImgUrl('btn-home')" gtm-label="account-balance.dashboard")
          .item
            a(href="javascript:void" @click="logout" gtm-label="account-balance.logout")
              img.buttons(:src="getImgUrl('btn-logout')" gtm-label="account-balance.logout")
</template>
<script>
  import api from '../library/api.js'
  import dayjs from 'dayjs'

  export default {
    data () {
      return {
        currentBalance: '0.00',
        lastUpdatedBalance: dayjs().format('DD/MM/YYYY'),
        nextExpired: [
          {
            balance: '0.00',
            date: '-'
          },
          {
            balance: '0.00',
            date: '-'
          }
        ]
      }
    },

    // -DEBUG
    created () {
      if (!window.localStorage.getItem('token')) {
        this.$router.push('/')
      }
    },

    mounted () {
      this.getBalance()
    },
    methods: {
      balance (num) {
        return num.toFixed(2)
      },

      getImgUrl (pic) {
        return require('../assets/images/' + pic + '-' + this.$LOCALE + '.png')
      },

      getBalance () {
        api('GetSmalishDallarsBalance')
          .then(res => {
            res = JSON.parse(res)
            this.currentBalance = this.balance(res.currentBalance)
            this.nextExpired[0].date = dayjs(res.pointsExpiringList[0].expiryDate).format('DD/MM/YYYY')
            this.nextExpired[0].balance = this.balance(res.pointsExpiringList[0].totalExpiring)
            if (res.pointsExpiringList[1].expiryDate) {
              this.nextExpired[1].date = dayjs(res.pointsExpiringList[1].expiryDate).format('DD/MM/YYYY')
              this.nextExpired[1].balance = this.balance(res.pointsExpiringList[1].totalExpiring)
            }
          })
          .catch(err => {
            console.error(err)
            if (err.status === 401 || err.status === 403) {
              window.localStorage.removeItem('token')
              this.$router.push('/')
            }
          })
      },

      logout () {
        api(`logout?token=${window.localStorage.getItem('token')}`)
        window.localStorage.removeItem('token')
        this.$router.push('/')
      }
    }
  }
</script>
<style lang="sass" scoped>
  @import "../sass/variables"

  #account-balance
    .black
      color: #555555

    .red
      color: #c80303

    .grey
      color: #666666

    .box
      position: relative
      margin: 0 auto
      padding: 20px
      width: 550px
      height: 100%
      border-radius: 15px
      box-shadow: 0 0 25px #9ecaed
      background-color: #ffffff
      @media #{$mobile}
        width: 100%
        box-shadow: 0 0

    .account-balance-container
      position: relative
      +mobile
        margin-top: 20px

    .title-img
      position: absolute
      top: -5.5%
      right: 5%
      max-width: 350px
      @media #{$mobile}
        position: relative
        left: 50%
        transform: translateX(-50%)

    .bank-counter
      position: relative
      width: 477px
      left: 50%
      transform: translateX(-50%)
      +mobile
        width: 115%

    .bank-amount
      position: absolute
      top: 51%
      left: 50%
      transform: translateX(-35%)
      font-size: 1.7em
      +mobile
        font-size: 1.4em

    .balance-desc
      text-align: center

    .balance-date
      font-size: 1.3em

    .redeem-desc
      text-align: center

    .button-container
      text-align: center
      display: flex
      justify-content: center
      img, a
        +desktop
          height: 40px

    .item
      img
        +mobile
          width: 100%
</style>
